import { themeSelector } from '_store/application/selectors';
import { AppTheme, DialogType } from '_store/application/types';
import { RsuStatusCode } from '_store/devices/devicesTypes';
import { RSU_WARNING_COLOR } from '_store/devices/utils';
import { SpatemActivityStatus } from '_store/spatem/spatemsTypes';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import {
  DENM_ICON_TRANSFORM,
  denmIconPaths,
  IVIM_ICON_TRANSFORM,
  ivimIconPaths,
} from './ivimDenmPaths';

interface IconMenuProps {
  type: DialogType;
  active: boolean;
}

const menuIconPath = (type: DialogType) => {
  switch (type) {
    case DialogType.HOME:
      return (
        <path
          d="
            M12.14 8
            c.218-.146.503-.146.722 0l6.17 4.16
            c.177.12.283.32.283.534
            v6.661
            c0 .171-.068.335-.19.456-.12.121-.285.189-.457.189h-3.392
            c-.172 0-.336-.068-.458-.189-.121-.12-.19-.285-.19-.456
            v-4.114
            c0-.356-.289-.645-.646-.645h-2.96
            c-.358 0-.647.289-.647.645
            v4.114
            c0 .171-.068.335-.19.456-.121.121-.286.189-.457.189H6.335
            c-.171 0-.336-.068-.457-.189-.121-.12-.19-.285-.19-.456
            v-6.664
            c0-.213.107-.413.284-.533
            zm0-3.89
            c.218-.147.503-.147.722 0l8.855 5.944
            c.152.103.253.266.277.448.025.182-.03.366-.15.506l-.733.83
            c-.214.241-.575.288-.844.109l-7.395-4.959
            c-.221-.15-.512-.15-.733 0l-7.402 4.964
            c-.27.179-.63.132-.845-.11l-.732-.83
            c-.122-.139-.178-.324-.155-.507.024-.183.126-.348.28-.451
            z"
        />
      );
    case DialogType.CREATE_IVIM:
    case DialogType.IVIM_LIST:
      return (
        <g transform={IVIM_ICON_TRANSFORM}>
          {ivimIconPaths.map((d, i) => (
            <path key={i} d={d} />
          ))}
        </g>
      );
    case DialogType.PMV_LIST:
      return (
        <g>
          <rect x="2" y="5" width="20" height="13" rx="3.5" />
          <rect x="5" y="8.5" width="6" height="2" rx="0.5" fill="#ffffff" />
          <rect x="5" y="12.5" width="11.5" height="2" rx="0.5" fill="#ffffff" />
        </g>
      );
    case DialogType.CREATE_DENM:
    case DialogType.DENM_LIST:
      return (
        <g transform={DENM_ICON_TRANSFORM}>
          {denmIconPaths.map((d, i) => (
            <path key={i} d={d} />
          ))}
        </g>
      );
    case DialogType.DEVICE:
      return (
        <path
          d="
            M18.514,11.66
            L4.684,11.66
            C4.50099844,11.6615844 4.32612234,11.7358046 4.19784597,11.8663314
            C4.0695696,11.9968582 3.99840176,12.1729986 3.99997365,12.356
            L3.99997365,19.304
            L19.200012,19.304
            L19.200012,12.356
            C19.202219,11.9745916 18.8954006,11.6633006 18.514,11.66
            Z M5.752,13.86
            C5.58224453,13.8632495 5.42738851,13.7634932 5.36016189,13.6075828
            C5.29293527,13.4516723 5.32669584,13.2705869 5.44558755,13.1493753
            C5.56447926,13.0281638 5.74487857,12.9909106 5.90205883,13.0551122
            C6.05923909,13.1193138 6.1619689,13.2722134 6.162,13.442
            C6.16414002,13.5526768 6.12208002,13.6596423 6.04512991,13.73922
            C5.9681798,13.8187976 5.86268624,13.8644241 5.752,13.866
            L5.752,13.86
            Z M7.908,13.86
            C7.73824453,13.8632495 7.58338851,13.7634932 7.51616189,13.6075828
            C7.44893527,13.4516723 7.48269584,13.2705869 7.60158755,13.1493753
            C7.72047926,13.0281638 7.90087857,12.9909106 8.05805883,13.0551122
            C8.21523909,13.1193138 8.3179689,13.2722134 8.318,13.442
            C8.32014002,13.5526768 8.27808002,13.6596423 8.20112991,13.73922
            C8.1241798,13.8187976 8.01868624,13.8644241 7.908,13.866
            L7.908,13.86
            Z M10.064,13.86
            C9.89424453,13.8632495 9.73938851,13.7634932 9.67216189,13.6075828
            C9.60493527,13.4516723 9.63869584,13.2705869 9.75758755,13.1493753
            C9.87647926,13.0281638 10.0568786,12.9909106 10.2140588,13.0551122
            C10.3712391,13.1193138 10.4739689,13.2722134 10.474,13.442
            C10.47614,13.5526768 10.43408,13.6596423 10.3571299,13.73922
            C10.2801798,13.8187976 10.1746862,13.8644241 10.064,13.866
            L10.064,13.86
            Z M19.2,19.422
            L19.2,19.768
            L19.1920808,19.8689192
            C19.1418372,20.1982402 18.8588885,20.4510239 18.516,20.454
            L18.516,20.454
            L4.684,20.454
            C4.30448772,20.4507014 3.99888559,20.141525 3.99999696,19.762
            L3.99999696,19.762
            L3.99999696,19.422
            L19.2,19.422
            Z M17.5985449,13.0552776
            C17.7554787,13.1196087 17.8579825,13.2723925 17.858,13.442
            C17.8601403,13.5530193 17.8178074,13.6602868 17.7404253,13.7399227
            C17.6630432,13.8195586 17.557035,13.8649529 17.446,13.866
            L17.446,13.86
            C17.27641,13.8624346 17.1221602,13.7621502 17.0555671,13.6061629
            C16.9889739,13.4501756 17.02324,13.2694112 17.1423005,13.1486168
            C17.261361,13.0278223 17.4416111,12.9909465 17.5985449,13.0552776
            Z M17.442,4.658
            C17.5315444,4.65746055 17.618237,4.68946246 17.686,4.748
            C17.7497595,4.80262348 17.7869217,4.88204863 17.788,4.966
            L17.788,4.966
            L18,11.46
            L16.8,11.46
            L17.094,4.966
            C17.105787,4.78521294 17.2611202,4.64773411 17.442,4.658
            Z M5.442,4.658
            C5.53154439,4.65746055 5.61823703,4.68946246 5.686,4.748
            C5.74975948,4.80262348 5.78692171,4.88204863 5.788,4.966
            L5.788,4.966
            L6,11.46
            L4.8,11.46
            L5.094,4.966
            C5.10578697,4.78521294 5.26112019,4.64773411 5.442,4.658
            Z M11.442,4.658
            C11.5315444,4.65746055 11.618237,4.68946246 11.686,4.748
            C11.7497595,4.80262348 11.7869217,4.88204863 11.788,4.966
            L11.788,4.966
            L12,11.46
            L10.8,11.46
            L11.094,4.966
            C11.105787,4.78521294 11.2611202,4.64773411 11.442,4.658
            Z"
          id="Shape"
        />
      );
    case DialogType.SETTINGS:
      return (
        <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" />
      );
    case DialogType.DASHBOARD:
      return (
        <path d="M3,3h7v7H3V3z M14,3h7v7h-7V3z M3,14h7v7H3V14z M14,14h7v7h-7V14z" id="Shape" />
      );
    case DialogType.AUDIT_LIST:
      return (
        <path d="M13,3c-4.97,0-9,4.03-9,9H1l3.89,3.89l0.07,0.14L9,12H6c0-3.87,3.13-7,7-7s7,3.13,7,7s-3.13,7-7,7 c-1.93,0-3.68-0.79-4.94-2.06l-1.42,1.42C8.27,19.99,10.51,21,13,21c4.97,0,9-4.03,9-9S17.97,3,13,3z M12,8v5l4.28,2.54l0.72-1.21 l-3.5-2.08V8H12z" />
      );
    case DialogType.SPATEM_LIST:
      return (
        <path
          fillRule="evenodd"
          d="M7.9915 0.42515C8.9135 0.3231 10.15295 0.24 11.7448 0.24s2.83125 0.0831 3.75325 0.18515c1.56075 0.17275 2.64635 1.3481 2.90795 2.76685h2.3783c0.65585 0 1.312 0.55805 1.16445 1.3347 -0.26255 1.38175 -1.11855 2.48425 -1.6193 3.03515 -0.35125 0.3864 -0.84205 0.55725 -1.31555 0.55725h-0.4197c0.00725 0.44725 0.0135 0.9195 0.01835 1.41725h2.1715c0.65585 0 1.312 0.55805 1.16445 1.33475 -0.26255 1.3817 -1.11855 2.4842 -1.6193 3.0351 -0.3513 0.3864 -0.84215 0.55725 -1.31555 0.55725h-0.4011c-0.00485 0.4982 -0.0111 0.9708 -0.0184 1.4183h2.19015c0.65585 0 1.312 0.558 1.16445 1.3347 -0.26255 1.38175 -1.11855 2.48425 -1.6193 3.03515 -0.35125 0.3864 -0.84205 0.55725 -1.31555 0.55725h-0.60805c-0.2619 1.41835 -1.34735 2.5933 -2.90785 2.766 -0.92195 0.10205 -2.16135 0.18515 -3.7532 0.18515 -1.5919 0 -2.8313 -0.08305 -3.7533 -0.18515 -1.56045 -0.1727 -2.64595 -1.34765 -2.90785 -2.766h-0.0976c-0.4734 0 -0.96425 -0.17085 -1.3155 -0.55725 -0.5008 -0.5509 -1.35675 -1.6534 -1.6193 -3.03515 -0.14755 -0.7767 0.5086 -1.3347 1.16445 -1.3347h1.6797c-0.0073 -0.44845 -0.01355 -0.922 -0.0184 -1.4213 -0.43875 -0.02445 -0.8821 -0.19745 -1.20645 -0.55425 -0.5008 -0.5509 -1.35675 -1.6534 -1.6193 -3.0351 -0.14755 -0.77675 0.5086 -1.33475 1.16445 -1.33475h1.66135c0.00485 -0.4986 0.01105 -0.9715 0.01835 -1.41935 -0.44475 -0.02055 -0.89595 -0.19335 -1.22485 -0.55515 -0.5008 -0.5509 -1.35675 -1.65345 -1.6193 -3.03515C1.9037 3.75 2.55985 3.192 3.2157 3.192h1.8678c0.26165 -1.41875 1.34725 -2.5941 2.908 -2.76685Zm3.7533 1.86005c-1.5207 0 -2.6849 0.0794 -3.52825 0.17275 -0.62635 0.06935 -1.11235 0.5801 -1.14695 1.32555 -0.0751 1.6159 -0.159 4.29815 -0.159 8.2165s0.0839 6.6006 0.159 8.2165c0.0346 0.74545 0.5206 1.25625 1.14695 1.32555 0.84335 0.09335 2.00755 0.17275 3.52825 0.17275 1.52065 0 2.68485 -0.0794 3.5282 -0.17275 0.62635 -0.06935 1.11235 -0.5801 1.14695 -1.32555 0.0751 -1.6159 0.159 -4.2982 0.159 -8.2165 0 -3.91835 -0.0839 -6.6006 -0.159 -8.2165 -0.0346 -0.74545 -0.5206 -1.2562 -1.14695 -1.32555 -0.84335 -0.09335 -2.00755 -0.17275 -3.5282 -0.17275Zm2.20825 3.88165c0 -1.21935 -0.98855 -2.2079 -2.2079 -2.2079 -1.2194 0 -2.2079 0.98855 -2.2079 2.2079 0 1.2194 0.9885 2.2079 2.2079 2.2079 1.21935 0 2.2079 -0.9885 2.2079 -2.2079Zm0 11.66715c0 -1.21945 -0.98855 -2.20795 -2.2079 -2.20795 -1.2194 0 -2.2079 0.9885 -2.2079 2.20795 0 1.21935 0.9885 2.2079 2.2079 2.2079 1.21935 0 2.2079 -0.98855 2.2079 -2.2079Zm-2.2081 -8.042c1.2194 0 2.2079 0.98855 2.2079 2.2079 0 1.2194 -0.9885 2.2079 -2.2079 2.2079 -1.21935 0 -2.2079 -0.9885 -2.2079 -2.2079 0 -1.21935 0.98855 -2.2079 2.2079 -2.2079Z"
          clipRule="evenodd"
          strokeWidth="1"
        />
      );
    default:
      return (
        <path
          d="
            M20.2444,8.3337
            C20.3985617,8.26861741 20.5751299,8.2855164 20.7141482,8.37865865
            C20.8531665,8.4718009 20.9359544,8.62867055 20.9344215,8.796
            L20.9344215,8.796
            L20.9344215,16.5723
            C20.9274873,16.9845807 20.6666533,17.3497483 20.2789,17.49
            L20.2789,17.49
            L15.9595,19.2564
            L15.9595,10.2864
            Z M7.2849,8.5614
            C7.47512079,9.06014129 7.70589309,9.54245541 7.9749,10.0035
            L7.9749,10.0035
            L7.9749,17.2416
            L3.69,19.1943
            C3.53583834,19.2593826 3.35927008,19.2424836 3.22025179,19.1493414
            C3.08123351,19.0561991 2.99844559,18.8993295 2.99997849,18.732
            L2.99997849,18.732
            L2.99997849,10.9557
            C3.01209368,10.5344204 3.28864754,10.1666038 3.69,10.038
            L3.69,10.038
            Z M14.948,11.5905
            L14.948,19.2288
            L8.9864,17.2416
            L8.9864,11.5905
            C9.5729,12.4323 10.2215,13.281 10.8356,13.971
            C11.115528,14.3069129 11.5299398,14.5014843 11.9672,14.5023
            C12.4044602,14.5014843 12.818872,14.3069129 13.0988,13.971
            C13.7129,13.2534 14.3615,12.4323 14.948,11.5905
            L14.948,11.5905
            Z M11.9672,3.3312
            C14.1279036,3.3312 15.8795,5.08279637 15.8795,7.2435
            C15.8795,8.9892 13.3196,12.177 12.3398,13.3293
            C12.248047,13.4405354 12.111394,13.5049594 11.9672,13.5049594
            C11.823006,13.5049594 11.686353,13.4405354 11.5946,13.3293
            C10.6148,12.177 8.0549,8.9892 8.0549,7.2435
            C8.0549,5.08279637 9.80649637,3.3312 11.9672,3.3312
            Z"
          id="Combined-Shape"
        />
      );
  }
};

const ConnexIcon = ({ active }: { active: boolean }) => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0 0 99.999992 100"
    enableBackground="new 0 0 417.962 102.132"
    xmlSpace="preserve"
  >
    <g transform="translate(3.20769,-0.962307)">
      <g>
        <circle
          fill="none"
          stroke={active ? '#005ABB' : '#82919b'}
          strokeWidth="2"
          strokeMiterlimit="10"
          cx="19.900999"
          cy="11.111"
          r="5.1750002"
        />
        <polygon
          fill={active ? '#005ABB' : '#82919b'}
          points="67.242,29.191 64.608,34.971 22.704,15.878 24.611,13.257 25.337,10.098"
        />
        <rect
          x="43.032001"
          y="15.579"
          transform="matrix(0.91,0.4146,-0.4146,0.91,12.8142,-21.518)"
          fill={active ? '#005ABB' : '#82919b'}
          width="25.872"
          height="6.3509998"
        />
        <rect
          x="63.298"
          y="26.583"
          transform="matrix(-0.4146,0.91,-0.91,-0.4146,126.7724,-22.0331)"
          fill={active ? '#005ABB' : '#82919b'}
          width="14.35"
          height="6.3509998"
        />
      </g>
      <g>
        <circle
          fill="none"
          stroke={active ? '#005ABB' : '#82919b'}
          strokeWidth="2"
          strokeMiterlimit="10"
          cx="6.6160002"
          cy="78.137001"
          r="5.1750002"
        />
        <polygon
          fill={active ? '#005ABB' : '#82919b'}
          points="24.696,30.796 30.476,33.429 11.383,75.335 8.762,73.428 5.603,72.702"
        />
        <rect
          x="1.323"
          y="38.894001"
          transform="matrix(0.4146,-0.91,0.91,0.4146,-29.936,37.6035)"
          fill={active ? '#005ABB' : '#82919b'}
          width="25.874001"
          height="6.3509998"
        />
        <rect
          x="18.087999"
          y="24.389"
          transform="matrix(0.91,0.4146,-0.4146,0.91,13.7016,-7.9934)"
          fill={active ? '#005ABB' : '#82919b'}
          width="14.349"
          height="6.3520002"
        />
      </g>
      <g>
        <circle
          fill="none"
          stroke={active ? '#005ABB' : '#82919b'}
          strokeWidth="2"
          strokeMiterlimit="10"
          cx="73.602997"
          cy="91.396004"
          r="5.1760001"
        />
        <polygon
          fill={active ? '#005ABB' : '#82919b'}
          points="26.261,73.317 28.894,67.538 70.8,86.631 68.893,89.251 68.167,92.41"
        />
        <rect
          x="24.599001"
          y="80.577003"
          transform="matrix(-0.91,-0.4146,0.4146,-0.91,36.9672,175.5307)"
          fill={active ? '#005ABB' : '#82919b'}
          width="25.872999"
          height="6.3520002"
        />
        <rect
          x="15.855"
          y="69.573997"
          transform="matrix(0.4146,-0.91,0.91,0.4146,-52.7213,63.5467)"
          fill={active ? '#005ABB' : '#82919b'}
          width="14.349"
          height="6.3520002"
        />
      </g>
      <g>
        <circle
          fill="none"
          stroke={active ? '#005ABB' : '#82919b'}
          strokeWidth="2"
          strokeMiterlimit="10"
          cx="86.867996"
          cy="24.414"
          r="5.1750002"
        />
        <polygon
          fill={active ? '#005ABB' : '#82919b'}
          points="68.788,71.754 63.009,69.121 82.101,27.215 84.722,29.123 87.881,29.849"
        />
        <rect
          x="66.289001"
          y="57.305"
          transform="matrix(-0.4146,0.91,-0.91,-0.4146,167.1095,13.4619)"
          fill={active ? '#005ABB' : '#82919b'}
          width="25.872999"
          height="6.3509998"
        />
        <rect
          x="61.046001"
          y="71.809998"
          transform="matrix(-0.91,-0.4147,0.4147,-0.91,99.2077,171.5094)"
          fill={active ? '#005ABB' : '#82919b'}
          width="14.35"
          height="6.3509998"
        />
      </g>
    </g>
  </svg>
);

const CamListMenuIcon = ({ active }: { active: boolean }) => {
  const fill = active ? '#005ABB' : '#82919b';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 320 272" xmlSpace="preserve">
      <g fill={fill}>
        <path
          d="
            M280.388184,169.514404 C296.032837,174.085312 299.685394,186.293381 301.238800,200.049683
            C301.950165,206.349197 302.672119,212.632004 302.248474,218.968460
            C301.540588,229.556686 296.233704,233.686661 285.479523,231.520981
            C287.695099,219.122040 285.633850,207.795273 275.289093,199.256317
            C268.954742,194.027725 261.669891,191.606262 253.483170,192.351257
            C243.957535,193.218079 236.546829,197.762619 231.046646,205.601517
            C225.486526,213.525864 225.425217,222.375214 226.881775,231.076660
            C224.753204,232.706909 222.853348,232.272995 221.070129,232.273911
            C176.570770,232.296799 132.071396,232.294571 87.572021,232.281265
            C81.119377,232.279327 81.119385,232.242813 81.837311,225.974792
            C83.834084,208.541397 71.235451,193.303848 54.031136,192.344315
            C36.091423,191.343765 21.912567,205.010284 22.093109,223.084564
            C22.109234,224.698776 22.661455,226.389145 21.417593,228.422943
            C17.527721,225.882584 15.722941,222.144211 14.765246,217.951141
            C13.187064,211.041382 13.166337,204.064896 14.645924,197.136032
            C17.484121,183.844849 17.994671,170.074158 23.420351,157.306992
            C28.079201,146.344269 34.442326,136.801895 44.026909,129.575760
            C45.914379,128.152725 47.677185,126.698479 47.918839,124.064476
            C48.279522,120.132988 50.853397,118.409935 54.434746,117.557442
            C64.033730,115.272530 73.838615,114.472961 83.618004,113.837044
            C107.906914,112.257622 132.223099,111.903442 156.523590,113.731049
            C170.424042,114.776474 182.925583,120.451729 195.319916,126.154930
            C209.862839,132.846786 223.890213,140.488632 236.744049,150.183517
            C244.008240,155.662445 252.730530,158.303970 261.095062,161.597137
            C267.446228,164.097610 273.730438,166.768112 280.388184,169.514404
            M123.418152,121.294533 C115.425743,121.306931 107.411736,120.950607 99.445923,121.417152
            C87.143181,122.137703 74.984512,123.984016 63.298115,128.198990
            C59.860172,129.438965 57.278503,131.458817 57.646866,135.390427
            C58.332870,142.712402 69.329865,154.417480 76.795395,155.402573
            C94.092873,157.684982 111.418320,159.781174 128.763016,161.672440
            C144.784149,163.419388 160.822952,165.110580 176.894501,166.259644
            C194.151825,167.493515 211.455490,168.084961 228.741211,168.908997
            C231.326828,169.032272 233.805771,168.579086 235.087311,165.894440
            C236.340347,163.269531 235.151825,160.993988 233.750076,158.895615
            C230.989594,154.763260 226.930954,152.067032 222.720978,149.691055
            C192.194504,132.462799 159.316956,123.321602 123.418152,121.294533
            M282.536469,187.929169 C287.076050,191.129288 291.513153,194.524170 297.429382,196.350998
            C290.064667,176.654892 281.289703,172.444901 261.311981,170.449478
            C267.754974,177.254135 274.881317,182.355194 282.536469,187.929169 z"
        />
        <path
          d="
            M76.946991,39.783295 C114.554970,24.053631 148.847443,29.128979 180.118896,54.567085
            C182.051071,56.138836 185.999496,57.500370 182.350571,61.492451
            C175.893036,68.557251 175.744675,68.758934 171.224152,64.777138
            C140.713196,37.902287 93.679985,37.860958 63.119522,64.615364
            C61.659466,65.893578 60.301140,68.916565 57.872089,67.070992
            C55.019012,64.903236 51.940437,62.588436 50.550381,59.112724
            C49.947659,57.605671 51.852146,56.586422 52.935562,55.613663
            C60.050457,49.225452 67.940979,43.997021 76.946991,39.783295 z"
        />
        <path
          d="
            M27.548752,208.759674 C35.498623,196.946854 48.077263,191.760986 59.556866,195.306564
            C71.768997,199.078354 80.152519,209.580490 80.187798,221.766571
            C80.222984,233.918182 74.490791,242.981110 63.546227,247.934586
            C52.782257,252.806290 42.198784,251.366013 33.434299,243.186142
            C24.860155,235.183929 21.760038,225.234467 25.490526,213.699982
            C25.999823,212.125229 26.738665,210.624725 27.548752,208.759674
            M61.520298,208.845932 C54.852562,204.945267 48.215340,204.920135 41.862103,209.397064
            C36.999763,212.823441 34.383167,220.331970 35.782879,225.812714
            C37.581772,232.856506 43.382523,238.155792 49.952431,238.757370
            C57.833557,239.479019 64.472717,235.736298 67.333687,228.958954
            C70.283379,221.971451 68.432510,214.997818 61.520298,208.845932 z"
        />
        <path
          d="
            M283.172302,215.247345 C286.241089,228.117218 280.903870,240.612366 269.947205,246.862503
            C259.679260,252.719772 245.874130,251.220154 237.382278,243.325043
            C227.760162,234.379074 225.262161,221.564148 230.883728,209.987015
            C235.768173,199.927902 246.810623,193.873734 258.972595,194.586914
            C269.847290,195.224594 278.943268,202.873932 283.172302,215.247345
            M242.852631,212.440247 C242.196274,213.594559 241.403824,214.693207 240.905411,215.912109
            C237.375870,224.543884 241.010773,233.655777 249.504562,237.610046
            C257.304504,241.241287 266.704437,237.885056 270.810669,230.002670
            C274.603912,222.721100 272.524780,213.918289 265.875824,209.108719
            C259.030060,204.156754 250.069397,205.244537 242.852631,212.440247 z"
        />
        <path
          d="
            M80.267525,66.180969 C107.110855,50.239647 139.857239,53.014462 163.477966,72.892372
            C166.334305,75.296104 167.415466,77.297821 163.934875,79.931534
            C162.882019,80.728218 161.925171,81.705452 161.101196,82.740738
            C158.793030,85.640869 156.756302,85.269173 154.045700,82.968117
            C143.646423,74.140076 131.461884,69.618881 117.864212,69.400398
            C104.057465,69.178543 91.544090,73.415031 80.993629,82.345993
            C77.215775,85.543938 74.835876,85.265549 72.122719,81.631607
            C70.844864,79.920067 68.800270,78.829109 67.907166,76.353096
            C71.183594,72.253304 75.496811,69.228325 80.267525,66.180969 z"
        />
        <path
          d="
            M89.269661,98.767990 C84.472633,93.860016 84.472641,93.860023 89.478851,90.003807
            C105.307243,77.811440 129.012634,77.790771 144.807724,89.996208
            C146.229294,91.094696 147.831833,92.081154 148.739120,94.186211
            C147.238159,97.431503 144.072815,99.447403 141.637802,102.066650
            C140.277740,103.529617 138.969116,102.632133 137.685699,101.692039
            C124.047699,91.702217 110.328560,91.683502 96.715431,101.640717
            C92.671196,104.598839 91.682625,100.498459 89.269661,98.767990 z"
        />
        <path
          d="
            M46.197853,215.120941 C51.428055,210.608566 58.839630,213.826492 60.783875,218.585266
            C62.949455,223.885788 60.451633,229.604156 54.950619,231.544540
            C50.549511,233.096924 47.059399,231.420197 44.415134,228.005844
            C41.529537,224.279892 42.182018,219.833847 46.197853,215.120941 z"
        />
        <path
          d="
            M250.808838,230.386414 C245.597260,224.907181 245.364517,219.272995 249.875717,215.352234
            C254.106766,211.675003 260.097015,212.252869 263.568329,216.673126
            C266.238770,220.073563 266.245850,224.850998 263.585510,228.243515
            C260.543549,232.122665 256.571747,232.879288 250.808838,230.386414 z"
        />
      </g>
    </svg>
  );
};

export const IconMenu: FC<IconMenuProps> = ({ type, active }) => {
  if (type === DialogType.CONNEX) {
    return <ConnexIcon active={active} />;
  }
  if (type === DialogType.CAM_LIST) {
    return <CamListMenuIcon active={active} />;
  }

  let fill = '#82919b';
  if (active) {
    fill = '#005ABB';
  }

  const isPmv = type === DialogType.PMV_LIST;
  const iconSize = isPmv ? 27 : 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <g fill="none">
        <g fill={fill}>{menuIconPath(type)}</g>
      </g>
    </svg>
  );
};

export const RsuStatus: FC<{ status?: RsuStatusCode }> = ({ status }) => {
  let color = null;
  const theme = useSelector(themeSelector);

  switch (status) {
    case RsuStatusCode.UP:
      color = 'green';
      break;
    case RsuStatusCode.WARNING:
      color = RSU_WARNING_COLOR;
      break;
    case RsuStatusCode.ERROR:
      color = 'red';
      break;
    default:
      color = theme === AppTheme.LIGHT ? '#82919b' : '#ffffff';
  }

  return (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="UX-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="RSU-lista_search" transform="translate(-402.000000, -372.000000)">
          <g id="component/Rsu/close" transform="translate(140.000000, 361.000000)">
            <g id="Group" transform="translate(262.000000, 11.000000)">
              <circle
                id="Oval"
                stroke={color}
                fillOpacity="0.5"
                fill="#ffffff"
                cx="11"
                cy="11"
                r="10.5"
              ></circle>
              <g id="icon/device" transform="translate(3.000000, 3.000000)" fill={color}>
                <path
                  d="M12.3426667,7.77333333
                    L3.12266667,7.77333333
                    C3.00066563,7.7743896 2.88408156,7.8238697 2.79856398,7.91088759
                    C2.7130464,7.99790548 2.66560118,8.11533237 2.6666491,8.23733333
                    L2.6666491,12.8693333
                    L12.800008,12.8693333
                    L12.800008,8.23733333
                    C12.8014793,7.98306104 12.5969337,7.77553374 12.3426667,7.77333333
                    Z M3.83466667,9.24
                    C3.72149635,9.24216633 3.61825901,9.17566212 3.57344126,9.07172184
                    C3.52862351,8.96778155 3.55113056,8.84705793 3.6303917,8.76625023
                    C3.70965284,8.68544253 3.82991905,8.66060708 3.93470589,8.70340814
                    C4.03949273,8.7462092 4.10797927,8.84814229 4.108,8.96133333
                    C4.10942668,9.03511784 4.08138668,9.10642819 4.03008661,9.15947997
                    C3.97878653,9.21253176 3.90845749,9.24294939 3.83466667,9.244
                    L3.83466667,9.24
                    Z M5.272,9.24
                    C5.15882969,9.24216633 5.05559234,9.17566212 5.01077459,9.07172184
                    C4.96595684,8.96778155 4.98846389,8.84705793 5.06772503,8.76625023
                    C5.14698617,8.68544253 5.26725238,8.66060708 5.37203922,8.70340814
                    C5.47682606,8.7462092 5.5453126,8.84814229 5.54533333,8.96133333
                    C5.54676001,9.03511784 5.51872001,9.10642819 5.46741994,9.15947997
                    C5.41611987,9.21253176 5.34579082,9.24294939 5.272,9.244
                    L5.272,9.24
                    Z M6.70933333,9.24
                    C6.59616302,9.24216633 6.49292567,9.17566212 6.44810793,9.07172184
                    C6.40329018,8.96778155 6.42579722,8.84705793 6.50505836,8.76625023
                    C6.5843195,8.68544253 6.70458571,8.66060708 6.80937255,8.70340814
                    C6.91415939,8.7462092 6.98264593,8.84814229 6.98266667,8.96133333
                    C6.98409334,9.03511784 6.95605335,9.10642819 6.90475327,9.15947997
                    C6.8534532,9.21253176 6.78312416,9.24294939 6.70933333,9.244
                    L6.70933333,9.24
                    Z M12.8,12.948
                    L12.8,13.1786667
                    L12.7922589,13.2605057
                    C12.7528214,13.4729011 12.5675125,13.63406 12.344,13.636
                    L12.344,13.636
                    L3.12266667,13.636
                    C2.86965848,13.6338009 2.66592373,13.4276833 2.66666464,13.1746667
                    L2.66666464,13.1746667
                    L2.66666464,12.948
                    L12.8,12.948
                    Z M11.7323633,8.70351841
                    C11.8369858,8.74640581 11.9053217,8.84826168 11.9053333,8.96133333
                    C11.9067602,9.03534621 11.8785383,9.10685785 11.8269502,9.15994847
                    C11.7753621,9.2130391 11.70469,9.24330196 11.6306667,9.244
                    L11.6306667,9.24
                    C11.5176067,9.24162304 11.4147735,9.17476681 11.370378,9.07077526
                    C11.3259826,8.96678371 11.3488266,8.84627411 11.4282003,8.7657445
                    C11.507574,8.6852149 11.6277408,8.66063101 11.7323633,8.70351841
                    Z M11.628,3.10533333
                    C11.6876963,3.1049737 11.7454914,3.12630831 11.7906667,3.16533333
                    C11.833173,3.20174898 11.8579478,3.25469908 11.8586667,3.31066667
                    L11.8586667,3.31066667
                    L12,7.64
                    L11.2,7.64
                    L11.396,3.31066667
                    C11.403858,3.19014196 11.5074135,3.09848941 11.628,3.10533333
                    Z M3.628,3.10533333
                    C3.68769626,3.1049737 3.74549136,3.12630831 3.79066667,3.16533333
                    C3.83317299,3.20174898 3.85794781,3.25469908 3.85866667,3.31066667
                    L3.85866667,3.31066667
                    L4,7.64
                    L3.2,7.64
                    L3.396,3.31066667
                    C3.40385798,3.19014196 3.50741346,3.09848941 3.628,3.10533333
                    Z M7.628,3.10533333
                    C7.68769626,3.1049737 7.74549136,3.12630831 7.79066667,3.16533333
                    C7.83317299,3.20174898 7.85794781,3.25469908 7.85866667,3.31066667
                    L7.85866667,3.31066667
                    L8,7.64
                    L7.2,7.64
                    L7.396,3.31066667
                    C7.40385798,3.19014196 7.50741346,3.09848941 7.628,3.10533333
                    Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SpatemStatus: FC<{ status?: SpatemActivityStatus }> = ({ status }) => {
  const theme = useSelector(themeSelector);
  let color: string;
  
  if (status === SpatemActivityStatus.ACTIVE) {
    color = 'green';
  } else if (status === SpatemActivityStatus.INACTIVE) {
    color = theme === AppTheme.LIGHT ? '#82919b' : '#ffffff';
  } else {
    color = theme === AppTheme.LIGHT ? '#82919b' : '#ffffff';
  }

  return (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <circle stroke={color} fillOpacity="0.5" fill="#ffffff" cx="12" cy="12" r="10.5" />
        <g fill={color} transform="translate(4, 4) scale(.69, .69)">
          <path
            clipRule="evenodd"
            d="M7.9915 0.42515C8.9135 0.3231 10.15295 0.24 11.7448 0.24s2.83125 0.0831 3.75325 0.18515c1.56075 0.17275 2.64635 1.3481 2.90795 2.76685h2.3783c0.65585 0 1.312 0.55805 1.16445 1.3347 -0.26255 1.38175 -1.11855 2.48425 -1.6193 3.03515 -0.35125 0.3864 -0.84205 0.55725 -1.31555 0.55725h-0.4197c0.00725 0.44725 0.0135 0.9195 0.01835 1.41725h2.1715c0.65585 0 1.312 0.55805 1.16445 1.33475 -0.26255 1.3817 -1.11855 2.4842 -1.6193 3.0351 -0.3513 0.3864 -0.84215 0.55725 -1.31555 0.55725h-0.4011c-0.00485 0.4982 -0.0111 0.9708 -0.0184 1.4183h2.19015c0.65585 0 1.312 0.558 1.16445 1.3347 -0.26255 1.38175 -1.11855 2.48425 -1.6193 3.03515 -0.35125 0.3864 -0.84205 0.55725 -1.31555 0.55725h-0.60805c-0.2619 1.41835 -1.34735 2.5933 -2.90785 2.766 -0.92195 0.10205 -2.16135 0.18515 -3.7532 0.18515 -1.5919 0 -2.8313 -0.08305 -3.7533 -0.18515 -1.56045 -0.1727 -2.64595 -1.34765 -2.90785 -2.766h-0.0976c-0.4734 0 -0.96425 -0.17085 -1.3155 -0.55725 -0.5008 -0.5509 -1.35675 -1.6534 -1.6193 -3.03515 -0.14755 -0.7767 0.5086 -1.3347 1.16445 -1.3347h1.6797c-0.0073 -0.44845 -0.01355 -0.922 -0.0184 -1.4213 -0.43875 -0.02445 -0.8821 -0.19745 -1.20645 -0.55425 -0.5008 -0.5509 -1.35675 -1.6534 -1.6193 -3.0351 -0.14755 -0.77675 0.5086 -1.33475 1.16445 -1.33475h1.66135c0.00485 -0.4986 0.01105 -0.9715 0.01835 -1.41935 -0.44475 -0.02055 -0.89595 -0.19335 -1.22485 -0.55515 -0.5008 -0.5509 -1.35675 -1.65345 -1.6193 -3.03515C1.9037 3.75 2.55985 3.192 3.2157 3.192h1.8678c0.26165 -1.41875 1.34725 -2.5941 2.908 -2.76685Zm3.7533 1.86005c-1.5207 0 -2.6849 0.0794 -3.52825 0.17275 -0.62635 0.06935 -1.11235 0.5801 -1.14695 1.32555 -0.0751 1.6159 -0.159 4.29815 -0.159 8.2165s0.0839 6.6006 0.159 8.2165c0.0346 0.74545 0.5206 1.25625 1.14695 1.32555 0.84335 0.09335 2.00755 0.17275 3.52825 0.17275 1.52065 0 2.68485 -0.0794 3.5282 -0.17275 0.62635 -0.06935 1.11235 -0.5801 1.14695 -1.32555 0.0751 -1.6159 0.159 -4.2982 0.159 -8.2165 0 -3.91835 -0.0839 -6.6006 -0.159 -8.2165 -0.0346 -0.74545 -0.5206 -1.2562 -1.14695 -1.32555 -0.84335 -0.09335 -2.00755 -0.17275 -3.5282 -0.17275Zm2.20825 3.88165c0 -1.21935 -0.98855 -2.2079 -2.2079 -2.2079 -1.2194 0 -2.2079 0.98855 -2.2079 2.2079 0 1.2194 0.9885 2.2079 2.2079 2.2079 1.21935 0 2.2079 -0.9885 2.2079 -2.2079Zm0 11.66715c0 -1.21945 -0.98855 -2.20795 -2.2079 -2.20795 -1.2194 0 -2.2079 0.9885 -2.2079 2.20795 0 1.21935 0.9885 2.2079 2.2079 2.2079 1.21935 0 2.2079 -0.98855 2.2079 -2.2079Zm-2.2081 -8.042c1.2194 0 2.2079 0.98855 2.2079 2.2079 0 1.2194 -0.9885 2.2079 -2.2079 2.2079 -1.21935 0 -2.2079 -0.9885 -2.2079 -2.2079 0 -1.21935 0.98855 -2.2079 2.2079 -2.2079Z"
            stroke-width="1"
          />
        </g>
      </g>
    </svg>
  );
};

interface IvimIconProps {
  active: boolean;
}
export const IvimIcon: FC<IvimIconProps> = ({ active }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none">
      <g fill={!active ? '#82919b' : '#005ABB'}>
        <g transform={IVIM_ICON_TRANSFORM}>
          {ivimIconPaths.map((d, i) => (
            <path key={i} d={d} />
          ))}
        </g>
      </g>
    </g>
  </svg>
);

interface IconDenmProps {
  active: boolean;
}
export const IconDenm: FC<IconDenmProps> = ({ active }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none">
      <g fill={!active ? '#82919b' : '#005ABB'}>
        <g transform={DENM_ICON_TRANSFORM}>
          {denmIconPaths.map((d, i) => (
            <path key={i} d={d} />
          ))}
        </g>
      </g>
    </g>
  </svg>
);

interface IconDeviceProps {
  active: boolean;
}
export const IconDevice: FC<IconDeviceProps> = ({ active }) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <g fill={!active ? '#82919b' : '#005ABB'}>
        <path
          d="
            M18.514,11.66
            L4.684,11.66
            C4.50099844,11.6615844 4.32612234,11.7358046 4.19784597,11.8663314
            C4.0695696,11.9968582 3.99840176,12.1729986 3.99997365,12.356
            L3.99997365,19.304
            L19.200012,19.304
            L19.200012,12.356
            C19.202219,11.9745916 18.8954006,11.6633006 18.514,11.66
            Z
            M5.752,13.86
            C5.58224453,13.8632495 5.42738851,13.7634932 5.36016189,13.6075828
            C5.29293527,13.4516723 5.32669584,13.2705869 5.44558755,13.1493753
            C5.56447926,13.0281638 5.74487857,12.9909106 5.90205883,13.0551122
            C6.05923909,13.1193138 6.1619689,13.2722134 6.162,13.442
            C6.16414002,13.5526768 6.12208002,13.6596423 6.04512991,13.73922
            C5.9681798,13.8187976 5.86268624,13.8644241 5.752,13.866
            L5.752,13.86
            Z
            M7.908,13.86
            C7.73824453,13.8632495 7.58338851,13.7634932 7.51616189,13.6075828
            C7.44893527,13.4516723 7.48269584,13.2705869 7.60158755,13.1493753
            C7.72047926,13.0281638 7.90087857,12.9909106 8.05805883,13.0551122
            C8.21523909,13.1193138 8.3179689,13.2722134 8.318,13.442
            C8.32014002,13.5526768 8.27808002,13.6596423 8.20112991,13.73922
            C8.1241798,13.8187976 8.01868624,13.8644241 7.908,13.866
            L7.908,13.86
            Z
            M10.064,13.86
            C9.89424453,13.8632495 9.73938851,13.7634932 9.67216189,13.6075828
            C9.60493527,13.4516723 9.63869584,13.2705869 9.75758755,13.1493753
            C9.87647926,13.0281638 10.0568786,12.9909106 10.2140588,13.0551122
            C10.3712391,13.1193138 10.4739689,13.2722134 10.474,13.442
            C10.47614,13.5526768 10.43408,13.6596423 10.3571299,13.73922
            C10.2801798,13.8187976 10.1746862,13.8644241 10.064,13.866
            L10.064,13.86
            Z M19.2,19.422
            L19.2,19.768
            L19.1920808,19.8689192
            C19.1418372,20.1982402 18.8588885,20.4510239 18.516,20.454
            L18.516,20.454
            L4.684,20.454
            C4.30448772,20.4507014 3.99888559,20.141525 3.99999696,19.762
            L3.99999696,19.762
            L3.99999696,19.422
            L19.2,19.422
            Z M17.5985449,13.0552776
            C17.7554787,13.1196087 17.8579825,13.2723925 17.858,13.442
            C17.8601403,13.5530193 17.8178074,13.6602868 17.7404253,13.7399227
            C17.6630432,13.8195586 17.557035,13.8649529 17.446,13.866
            L17.446,13.86
            C17.27641,13.8624346 17.1221602,13.7621502 17.0555671,13.6061629
            C16.9889739,13.4501756 17.02324,13.2694112 17.1423005,13.1486168
            C17.261361,13.0278223 17.4416111,12.9909465 17.5985449,13.0552776
            Z M17.442,4.658
            C17.5315444,4.65746055 17.618237,4.68946246 17.686,4.748
            C17.7497595,4.80262348 17.7869217,4.88204863 17.788,4.966
            L17.788,4.966
            L18,11.46
            L16.8,11.46
            L17.094,4.966
            C17.105787,4.78521294 17.2611202,4.64773411 17.442,4.658
            Z M5.442,4.658
            C5.53154439,4.65746055 5.61823703,4.68946246 5.686,4.748
            C5.74975948,4.80262348 5.78692171,4.88204863 5.788,4.966
            L5.788,4.966
            L6,11.46
            L4.8,11.46
            L5.094,4.966
            C5.10578697,4.78521294 5.26112019,4.64773411 5.442,4.658
            Z M11.442,4.658
            C11.5315444,4.65746055 11.618237,4.68946246 11.686,4.748
            C11.7497595,4.80262348 11.7869217,4.88204863 11.788,4.966
            L11.788,4.966
            L12,11.46
            L10.8,11.46
            L11.094,4.966
            C11.105787,4.78521294 11.2611202,4.64773411 11.442,4.658
            Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);

interface IconMapProps {
  active: boolean;
}
export const IconMap: FC<IconMapProps> = ({ active }) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <g fill={!active ? '#82919b' : '#005ABB'}>
        <path
          d="M20.2444,8.3337
            C20.3985617,8.26861741 20.5751299,8.2855164 20.7141482,8.37865865
            C20.8531665,8.4718009 20.9359544,8.62867055 20.9344215,8.796
            L20.9344215,8.796
            L20.9344215,16.5723
            C20.9274873,16.9845807 20.6666533,17.3497483 20.2789,17.49
            L20.2789,17.49
            L15.9595,19.2564
            L15.9595,10.2864
            Z
            M7.2849,8.5614
            C7.47512079,9.06014129 7.70589309,9.54245541 7.9749,10.0035
            L7.9749,10.0035
            L7.9749,17.2416
            L3.69,19.1943
            C3.53583834,19.2593826 3.35927008,19.2424836 3.22025179,19.1493414
            C3.08123351,19.0561991 2.99844559,18.8993295 2.99997849,18.732
            L2.99997849,18.732
            L2.99997849,10.9557
            C3.01209368,10.5344204 3.28864754,10.1666038 3.69,10.038
            L3.69,10.038
            Z
            M14.948,11.5905
            L14.948,19.2288
            L8.9864,17.2416
            L8.9864,11.5905
            C9.5729,12.4323 10.2215,13.281 10.8356,13.971
            C11.115528,14.3069129 11.5299398,14.5014843 11.9672,14.5023
            C12.4044602,14.5014843 12.818872,14.3069129 13.0988,13.971
            C13.7129,13.2534 14.3615,12.4323 14.948,11.5905
            L14.948,11.5905
            Z M11.9672,3.3312
            C14.1279036,3.3312 15.8795,5.08279637 15.8795,7.2435
            C15.8795,8.9892 13.3196,12.177 12.3398,13.3293
            C12.248047,13.4405354 12.111394,13.5049594 11.9672,13.5049594
            C11.823006,13.5049594 11.686353,13.4405354 11.5946,13.3293
            C10.6148,12.177 8.0549,8.9892 8.0549,7.2435
            C8.0549,5.08279637 9.80649637,3.3312 11.9672,3.3312
            Z"
          id="Combined-Shape"
        ></path>
      </g>
    </g>
  </svg>
);

export const AlertIcon: FC = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 40 49"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>68D87533-046B-453A-A71F-8F73A6A3E6C1</title>
    <g id="UX-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Creazione-Denm_modale" transform="translate(-393.000000, -407.000000)" fill="#444E53">
        <g id="icon/alert" transform="translate(393.000000, 407.500000)">
          <path
            d="
              M24,4
              C12.954305,4 4,12.954305 4,24
              C4,35.045695 12.954305,44 24,44
              C35.045695,44 44,35.045695 44,24
              C44,12.954305 35.045695,4 24,4
              L24,4
              L24,4
              L24,4
              L24,4
              Z
              M22.1818182,25.8181818
              L22.1818182,14.9090909
              L25.8181818,14.9090909
              L25.8181818,25.8181818
              L22.1818182,25.8181818
              L22.1818182,25.8181818
              L22.1818182,25.8181818
              Z M25.8181818,33.0909091
              L22.1818182,33.0909091
              L22.1818182,29.4545455
              L25.8181818,29.4545455
              L25.8181818,33.0909091
              L25.8181818,33.0909091
              L25.8181818,33.0909091
              Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const AlertIconRed: FC = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 40 49"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>68D87533-046B-453A-A71F-8F73A6A3E6C1</title>
    <g id="UX-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Creazione-Denm_modale" transform="translate(-393.000000, -407.000000)" fill="#cd3a3a">
        <g id="icon/alert" transform="translate(393.000000, 407.500000)">
          <path
            d="
              M24,4
              C12.954305,4 4,12.954305 4,24
              C4,35.045695 12.954305,44 24,44
              C35.045695,44 44,35.045695 44,24
              C44,12.954305 35.045695,4 24,4
              L24,4
              L24,4
              L24,4
              L24,4
              Z
              M22.1818182,25.8181818
              L22.1818182,14.9090909
              L25.8181818,14.9090909
              L25.8181818,25.8181818
              L22.1818182,25.8181818
              L22.1818182,25.8181818
              L22.1818182,25.8181818
              Z
              M25.8181818,33.0909091
              L22.1818182,33.0909091
              L22.1818182,29.4545455
              L25.8181818,29.4545455
              L25.8181818,33.0909091
              L25.8181818,33.0909091
              L25.8181818,33.0909091
              Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

const eventColors = {
  scheduled: 'b900ff',
  progress: '4fca4f',
  terminated: '42414b',
  default: '82919b',
  disabled: 'ffa500',
};
export const eventIcon = (base64data: string, status?: string): string => {
  const base64Icon = `data:image/png;base64,${base64data}`;
  const colorBg = status in eventColors ? eventColors[status] : eventColors.default;

  return `<svg
    width="500px"
    height="589px"
    viewBox="0 0 500 589"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
      <circle id="Oval" cx="250" cy="250" r="250" fill="%23${colorBg}"></circle>
      <path
        d="
          M250,322
          C269,322 313, 411 383, 588
          L116,588
          C186,411 230,322 250,322
          Z"
        id="Triangle"
        transform="
          translate(250.000000, 455.555556)
          scale(-1, 1)
          rotate(-180.000000)
          translate(-250.000000,
          -455.555556)"
        fill="%23${colorBg}"></path>
      <image href="${base64Icon}" x="58" y="1" width="75%" height="75%"/>
  </svg>`;
};

export const ManualIcon: FC<{ active?: boolean }> = ({ active = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M31.56,5.69h9.7V30.76H30.64l-.59,0-.33,0-.61.06-.37,0-.65.11-.36.07c-.26.06-.52.14-.78.22l-.23.07a6.93,6.93,0,0,0-1,.42l-.23.14a5.42,5.42,0,0,0-.53.33V12.24A6.56,6.56,0,0,1,31.56,5.69Zm-24.82,0h9.7A6.56,6.56,0,0,1,23,12.24V32.29a5.4,5.4,0,0,0-.52-.33l-.24-.15a7.1,7.1,0,0,0-.95-.42L21,31.33c-.25-.08-.51-.16-.76-.22L19.91,31l-.64-.11-.38,0-.6-.06-.34,0-.59,0H6.74V5.69ZM46,35.7a.75.75,0,0,1-.75.74H32.8c-5.72,0-8.05,1.48-8.05,5.12a.74.74,0,1,1-1.49,0c0-3.64-2.33-5.12-8-5.12H2.75A.75.75,0,0,1,2,35.7V8.87a.75.75,0,0,1,.75-.75h2V31.77a1,1,0,0,0,1,1H16.44c5.43,0,6.55,1.61,6.55,4a1,1,0,1,0,2,0c0-2.42,1.11-4,6.55-4H42.27a1,1,0,0,0,1-1V8.12h2a.75.75,0,0,1,.75.75Z"
      fill={active ? '#005ABB' : '#82919b'}
    />
  </svg>
);
